import React, { useState, useEffect } from 'react';
import StatCard from '../../components/StatCard';
import { cloudAPI } from '../../utils/api';

export default function OverviewPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getOverview()
            .then(res => setData(res.data))
            .catch(err => console.error('Overview error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;
    if (!data) return <div className="text-red-500">Failed to load</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Overview</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatCard title="Total Devices" value={data.total_devices || 0} subtitle="Registered installs" />
                <StatCard title="Total Sessions" value={data.total_sessions || 0} subtitle="All time" />
                <StatCard title="Sessions Today" value={data.sessions_today || 0} subtitle="Last 24h" />
                <StatCard title="Error Rate" value={`${data.error_rate_24h || 0}%`} subtitle="Last 24h" />
            </div>
        </div>
    );
}
